import { render, staticRenderFns } from "./Specialist.vue?vue&type=template&id=10c89366&scoped=true"
import script from "./Specialist.vue?vue&type=script&lang=js"
export * from "./Specialist.vue?vue&type=script&lang=js"
import style0 from "./Specialist.vue?vue&type=style&index=0&id=10c89366&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c89366",
  null
  
)

export default component.exports